import { render, staticRenderFns } from "./LInkAdmin.vue?vue&type=template&id=6ff98997&scoped=true"
import script from "./LInkAdmin.vue?vue&type=script&lang=js"
export * from "./LInkAdmin.vue?vue&type=script&lang=js"
import style0 from "./LInkAdmin.vue?vue&type=style&index=0&id=6ff98997&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff98997",
  null
  
)

export default component.exports